import angular from 'angular';
import { filter, map, random } from 'lodash';

import { getErrorMessage } from 'application/util/error.util';
import { isCategoryListable, categoryHasTerms } from 'application/util/category.util';

import './category-select-modal.style.sass';
import template from './category-select-modal.tpl.pug';

class CategorySelectModalController {
    /* @ngInject */
    constructor(categoryService, modalService, notificationService, storageService) {
        this.categoryService = categoryService;
        this.modalService = modalService;
        this.notificationService = notificationService;
        this.storageService = storageService;
    }

    $onInit() {
        const categoryIconStyle = this.storageService.getUserItem('category-icon-style') || 'icons';
        this.useCategoryIcons = categoryIconStyle === 'icons';
        this.categoryService.onUpdate(this.handleCategoryUpdate.bind(this));
        this.reload();
    }

    reload() {
        this.loading = true;

        return this.categoryService.getAll(this.teamId, true).then((categories) => {
            this.categories = map(filter(categories, isCategoryListable), (category) => {
                return angular.merge({
                    selected: category.id === this.selectedCategoryId
                }, category);
            });
            this.searchPlaceholder = this.categories.length > 0
                ? `search for e.g. ${this.categories[random(0, this.categories.length - 1)].name}`
                : null;

            this.search();
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to load your categories. Please try again later.`));
        }).finally(() => this.loading = false);
    }

    handleCategoryUpdate(updatedCategory) {
        if (!updatedCategory || !updatedCategory.id) {
            return this.reload();
        }

        let replaced = false;
        this.categories = map(this.categories || [], (category) => {
            if (`${category.id}` === `${updatedCategory.id}`) {
                replaced = true;
                return angular.merge({}, category, updatedCategory, {
                    selected: category.id === this.selectedCategoryId
                });
            }

            return category;
        });

        if (!replaced) {
            return this.reload();
        }

        return this.search();
    }

    select(category) {
        return this.onClose({
            data: category
        });
    }

    create() {
        return this.modalService.open({
            component: 'dbACategoryEditModal',
            bindings: {
                teamId: this.teamId,
                canEdit: true,
                from: 'event'
            }
        }).then(this.select.bind(this)).catch(() => null);
    }

    manage() {
        return this.modalService.open({
            component: 'dbACategoryManageModal',
            bindings: {
                teamId: this.teamId
            }
        }).finally(() => this.reload()).catch(() => null);
    }

    searchBySubmit(terms) {
        let valid = this.search(terms);

        if (valid && this.filteredCategories.length > 0) {
            this.select(this.filteredCategories[0]);
        }
    }

    search(terms) {
        let valid = terms && terms.length > 0;

        this.filteredCategories = valid
            ? filter(this.categories, (category) => categoryHasTerms(category, terms))
            : this.categories;

        return valid;
    }

    dismiss() {
        this.onDismiss();
    }
}

export default {
    selector: 'dbACategorySelectModal',
    template: template(),
    controller: CategorySelectModalController,
    bindings: {
        teamId: '<',
        selectedCategoryId: '<',

        canAdd: '<',

        onClose: '&',
        onDismiss: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-select-modal/category-select-modal.cmpt.js